import * as React from "react"
import type { SVGProps } from "react"
const SvgChatConversation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21 20.89a1 1 0 0 1-.37-.08 1 1 0 0 1-.33-.22l-2.3-2.3H8q-.82 0-1.41-.6A2 2 0 0 1 6 16.3v-1h11q.83 0 1.41-.6.6-.57.59-1.4v-7h1q.83 0 1.41.58.6.6.59 1.42v11.57q0 .45-.3.74a1 1 0 0 1-.7.28M4 12.46l1.18-1.17H15v-7H4zm-1 3.43a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.73V4.29q0-.83.59-1.42A2 2 0 0 1 4 2.3h11q.83 0 1.41.58.6.6.59 1.42v7q0 .83-.59 1.4a2 2 0 0 1-1.41.6H6l-2.3 2.3q-.15.15-.32.22a1 1 0 0 1-.38.08" />
  </svg>
)
export default SvgChatConversation
